import React, { useEffect, useState } from 'react';

import Typography from '@mui/material/Typography';
import {
  Assignment,
  Business,
  DevicesOutlined,
  DirectionsBusOutlined,
  GroupOutlined,
  GroupsOutlined,
  Inventory,
  SimCard,
} from '@mui/icons-material';

import { DashboardContainer } from '../../../components/dashboard';
import EventContainer from '../../../components/Events/EventContainer';
import FullLayout from '../../../layouts/fullLayout';
import { useBoundStore } from '../../../stores';

const Definitions = () => {
  const textPool = useBoundStore((state) => state.textPool);

  const sx = {
    fontSize: '80px',
  };

  const definitionsData = [
    {
      title: "Atamalar",
      icon: <Assignment sx={sx} color="secondary" />,
      to: '/definitions/assignments',
    },
    {
      title: textPool['Cihazlar'],
      icon: <DevicesOutlined sx={sx} color="secondary" />,
      to: '/definitions/devices',
    },
    {
      title: "SIM Kartlar",
      icon: <SimCard sx={sx} color="secondary" />,
      to: '/definitions/simcards',
    },
    {
      title: "Ürünler",
      icon: <Inventory sx={sx} color="secondary" />,
      to: '/definitions/products',
    },
    {
      title: "Şirketler",
      icon: <Business sx={sx} color="secondary" />,
      to: '/definitions/companies',
    },
    {
      title: textPool['Kullanıcılar'],
      icon: <GroupOutlined sx={sx} color="secondary" />,
      to: '/definitions/users',
    },

    // {
    //   title: textPool['Sürücüler'],
    //   icon: <GroupsOutlined sx={sx} color="secondary" />,
    //   to: '/definitions/drivers',
    // },
  ];
  return (
    <FullLayout>
      <Typography variant="h4" gutterBottom sx={{ paddingX: '1.25rem' }}>
        {textPool['Merhaba,'] +
          ` ${JSON.parse(localStorage.getItem('user'))?.username}!`}
      </Typography>
      <DashboardContainer data={definitionsData} />
      {/* <EventContainer /> */}
    </FullLayout>
  );
};

export default Definitions;
